/**
 * patient-portal capability keys — the EXACT server capability strings
 * (server/src/modules/patient-portal/patient-portal.module.js + routes.js, server/src/config/rbac.config.js).
 * useCan / nav gating / ProtectedRoute all key off these. The server re-checks every request; these
 * only hide/disable UI (never the trust boundary).
 *
 * Mounted lab-staff routes (CLOUD installs only):
 *   GET /portal/publish-gate/:patientId  → patient-portal.resultat.publish
 *   GET /portal/resultats/:demandeId     → patient-portal.dossier.lire
 * The consent-read surface reads the LIVE publish-gate verdict (canPublishToNovera) and is gated on
 * patient-portal.consentement.read (the dedicated read capability in the RBAC catalog).
 */
export const PP_CAPS = {
  /** Read the live central consent state (publication_novera) for a patient. */
  consentementRead: "patient-portal.consentement.read",
  /** The seam-4 publish gate: may this lab publish a result back to Novera for this patient? */
  resultatPublish: "patient-portal.resultat.publish",
  /** Read a patient's emitted compte-rendu (the result-view). */
  dossierLire: "patient-portal.dossier.lire",
} as const;

export type PatientPortalCapability = (typeof PP_CAPS)[keyof typeof PP_CAPS];
